import { logout as logoutAPI } from '@/services/ant-design-pro/api';
import { useAuthStore } from '@/store/auth';
import { useNavigate } from 'react-router';

function useAuth() {
  const { setAccessToken, setRefreshToken, setCurrentUser, setCurrentProject } = useAuthStore();
  const navigate = useNavigate();

  /**
   * 清除登录用户相关数据
   */
  const clearAuthData = () => {
    setAccessToken('');
    setRefreshToken('');
    setCurrentUser(null);
    setCurrentProject(null);
    navigate('/user/login', { replace: true });
  };

  /**
   * 退出
   */
  const logout = async () => {
    try {
      await logoutAPI();
    } catch (error) {
      console.error(error);
    } finally {
      // 无论后端登出请求是否成功，都清除本地登录态，确保用户已退出
      clearAuthData();
    }
  };

  return {
    logout,
    clearAuthData,
  };
}

export default useAuth;
